import { createBrowserHistory } from "history";

//API CALL TYPE
//const TYPE_LOCAL = "LOCAL";
const TYPE_REST = "REST";
//console.log(77, process.env.NODE_ENV);

//resources
// const API_URL =
//   process.env.NODE_ENV === "production" ? "" : "https://dev.senshost.net/api";
//const API_URL = "http://senshost.com:8015/api";
const SOCKET_URL = "mqtt://senshost.com";
//API contexts
//We will pass this to swagger class constractor if we need different base urls
//const DEFAULT = "";
//const SECONDARY = "/something";

export enum APILIST {
  AUTH = "Auth",
  ACCOUNT = "Account",
  ACCOUNTS = "Accounts",
  DEVICE = "Device",
  DEVICES = "Devices",
  DEVICEITEM = "dataValue",
  DEVICEIDENTITY = "device-identity",
  COLLECTION = "Collection",
  EVENT = "events",
  BUILDING = "buildings",
  BATS = "bats",
  ASSET = "assets",
  LEVEL = "level",
  ROOM = "room",
  TRIGGER = "Trigger",
  COLLECTIONITEM = "collection-items",
  Group = "Group",
  Sensor = "DataField",
  SensorValue = "DataValue",
  Actuator = "actuator",
  Attribute = "attribute",
  Action = "Action",
  User = "user",
  Digest = "Digest",
  Settings = "Settings",
  Dashboard = "dashboard",
  DashboardItem = "dashboardItem",
  Trigger = "Trigger",
  Part = "Part",
  Vendor = "Vendor",
  Project = 'Project',
  Attendance = 'Attendance'
}

//CONFIG DATA — URLs are controlled by .env.development / .env.production
const configs = {
  delay: 500,
  dashbordRefreshRate: 1,
  port: 8015,
  appName: "senshost",
  toastDelay: 5000,
  tokenStorage: "TOKEN_PERSIST",
  socket: SOCKET_URL,
  type: TYPE_REST,
  context: process.env.REACT_APP_API_URL || "https://api.prod.senshost.com/api",
  digestUrl: process.env.REACT_APP_DIGEST_URL || "https://api.prod.senshost.com/digest/api",
  filePath: process.env.REACT_APP_FILE_PATH || "https://api.prod.senshost.com/Files",
  context2: process.env.REACT_APP_BASE_URL || "https://api.prod.senshost.com",
  mockContext: "https://3ad773e3-829d-430e-8871-1e0e52a9f78a.mock.pstmn.io/api",
  mockfilePath: "https://3ad773e3-829d-430e-8871-1e0e52a9f78a.mock.pstmn.io/Files",
  history: createBrowserHistory(),
  requestTimeOut: 3000000,
  apiList: APILIST,
  tablePageSize: 100,
};
export default configs;
